import React, {useMemo} from "react";
import {Button} from "primereact/button";
import {Tag} from "primereact/tag";
import {buildSearchNeeds, digits} from "./help-cms";
import {TabHeader} from "./ui";

export default function SearchNeedsTab({data, onNew}) {
    const needs = useMemo(() => buildSearchNeeds(data.logs, data.contents), [data.logs, data.contents]);

    return (
        <div className="flex flex-column gap-3">
            <TabHeader kicker="نیازهای کاربران" title="جست‌وجوهای بدون پاسخ" description="این‌ها کلماتی هستند که کاربر جست‌وجو کرده اما پاسخ مناسبی نگرفته است."/>

            <div className="surface-100 border-round-lg p-3 text-sm">
                <b>اولویت پیشنهادی: </b>
                <span className="text-600">اول محتوایی را بسازید که جست‌وجوی بیشتری دارد و باعث تماس با پشتیبانی شده است.</span>
            </div>

            <div className="flex flex-column gap-2">
                {needs.map((need, index) => (
                    <div key={need.query} className="surface-card border-1 border-200 border-round-xl p-3 flex align-items-center gap-3">
                        <span className="surface-100 border-circle flex align-items-center justify-content-center font-bold" style={{width: 32, height: 32}}>{digits(index + 1)}</span>
                        <div className="flex-1">
                            <b className="block text-sm">{need.query}</b>
                            <small className="text-500">{digits(need.count)} جست‌وجو در ۳۰ روز اخیر</small>
                        </div>
                        <Tag value={need.label} severity={need.best === 0 ? "danger" : "warning"}/>
                        <Button className="p-button-outlined p-button-sm text-xs" label="ساخت محتوا" onClick={() => onNew(need.query)}/>
                    </div>
                ))}
                {!needs.length && <div className="text-sm text-500 p-3">در ۳۰ روز اخیر جست‌وجوی بی‌پاسخی ثبت نشده است.</div>}
            </div>
        </div>
    );
}
